// The one setup sequence, shown on the landing CTA, beside Register, and on
// /setup while a workspace waits. Telephony is its own step because it is the
// real gate before calling opens.
export const SETUP_STEPS = [
  {
    id: "account",
    title: "Create your account",
    doneTitle: "Account created",
    text: "Your team and company details.",
  },
  {
    id: "review",
    title: "Workspace review",
    text: "The NexusDialer team confirms your calling requirements.",
  },
  {
    id: "calling",
    title: "Calling setup",
    text: "Telephony is configured before calling opens.",
  },
  {
    id: "session",
    title: "First session",
    text: "Import a list, start a campaign, press Space.",
  },
];
